import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  generateWidthByscreenSize,
  isMobile,
  isDesktop,
  isIpad,
  generateWidthForIpad,
} from '../../global/ScreenSizeHelper';
import fallBackImage from '../../global/assets/svg/ImageError.svg';
import imageUrlTransformation from '../../global/imageUrlTransformation';
import Loader from '../Loader/Loader';
// import './ProductCard.scss';
import AtomicCircleButton from '../../atomic/AtomicCircleButton/AtomicCircleButton';
import AtomicSpeedDialIcons from '../../atomic/AtomicSpeedDialIcons/AtomicSpeedDialIcons';
import AtomicChip from '../../atomic/AtomicChip/AtomicChip';
import { Rating } from '@mui/material';
import { OnTheMenuDataContext } from '../../context-api/OnTheMenuDataProvider';
import { LoginDataContext } from '../../context-api/LoginDataProvider';
import AlertDialog from '../../atomic/Dialog/Dialog';
import { SpecialMarkingIcons } from '../../global/assets/Icons';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import TextTransformation from '../../global/textTransformation';
import { CheckoutDataContext } from '../../context-api/CheckoutDataProvider';
import { GlobalStateDataContext } from '../../context-api/GlobalStateDataProvider';

const ProductCard = (props) => {
  const { product, mealType } = props;
  const navigate = useNavigate();
  const { urlValidationResponse } = useContext(GlobalStateDataContext);
  const { setOrderConfirmationData, setPromoCodeOrderSummary } = useContext(CheckoutDataContext);
  const {
    kitchenData,
    storeName,
    setStoreName,
    setSelectedDate,
    productsData = {},
    sortedKitchenData,
    setProductsData,
    cartItems,
    setCartItems,
    setRemainingMealItemsCategoryWise,

    oneTimeMeal,
    setOneTimeMeal,
    howManyPerson,
    setHowManyPerson,
  } = useContext(OnTheMenuDataContext);
  const { isLoggedIn, customerInfoData } = useContext(LoginDataContext);
  const { loading, data, success, errorMessage } = customerInfoData;
  const custInfoData = data?.data || [];
  const { kitchenName, meal_offering, opening_status, status } = sortedKitchenData;
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const [isAlertOpen, setAlertOpen] = useState(false);
  const [showAgreeButton, setshowAgreeButton] = useState(true);
  const [showDisagreeButton, setshowDisagreeButton] = useState(true);
  const [displayText, setdisplayText] = useState('');
  const [buttonAgreeLabel, setButtonAgreeLabel] = useState('Okay');
  const RedirectToAddAddress = async () => await navigate(`/customeraccount/deliveryaddress`);
  const BaseObj = urlValidationResponse?.data?.data?.data?.promoCodeValidation;

  // Customer Status
  const custActType = custInfoData?.user_Info?.account_type === 'Subscription';
  const zeroPlatesAvailable = custInfoData?.available_plates === 0; // Chck with kuldeep

  const StoreNameMatch = product?.kitchen_name === BaseObj?.createdBy;
  const ProductNameMatch = product.product_name === BaseObj?.product_name;
  const IsFreeProduct = ProductNameMatch && StoreNameMatch;

  const PromoVerbage = () => {
    if (BaseObj?.code?.includes('pa')) {
      if (BaseObj?.type === 'product') {
        return (
          <div
            style={{
              fontFamily: 'Inter Regular',
              padding: 5,
              width: 'auto',
              borderRadius: '3px',
              backgroundColor: '#dff5cf',
              fontSize: '14px',
              marginTop: '10px',
              border: '2px solid #86c49a',
            }}
          >
            {' '}
            <span style={{ color: 'green', fontFamily: 'Inter Medium' }}> FREE </span>{' '}
            <span style={{ textTransform: 'capitalize', fontFamily: 'Inter Bold' }}>
              {BaseObj?.product_name}
            </span>{' '}
            – Spend ${BaseObj?.minimumOrderValue} {''} Use Code :{' '}
            <span style={{ textTransform: 'uppercase', fontFamily: 'Inter Bold' }}>
              {BaseObj?.code}
            </span>
          </div>
        );
      }
    } else {
      return;
    }
  };

  const onImageLoad = () => {
    setImageLoaded(true);
  };

  const onImageError = () => {
    setImageError(true);
    setImageLoaded(true);
  };

  const onAlertAgree = () => {
    if (buttonAgreeLabel === 'Add Address') {
      RedirectToAddAddress();
      return;
    }
    setCartItems({});
    setSelectedDate();
    setAlertOpen(false);
  };

  const onAlertDisagree = () => {
    setAlertOpen(false);
  };

  const setDisabledAddToCartBtn_MealItem = () => {
    const newProductListCategory = productsData?.data?.categorizedProducts?.[
      kitchenName
    ]?.MealItems?.[product.product_category]?.map((item) => ({
      ...item,
      disabled: true,
    }));

    setProductsData({
      ...productsData,
      data: {
        ...productsData?.data,
        categorizedProducts: {
          ...productsData?.data?.categorizedProducts,
          [kitchenName]: {
            ...productsData?.data?.categorizedProducts?.[kitchenName],
            MealItems: {
              ...productsData?.data?.categorizedProducts?.[kitchenName]?.MealItems,
              [product.product_category]: newProductListCategory,
            },
          },
        },
      },
    });
  };
  const setDisabledAddToCartBtn_NonMealItem = () => {
    const newProductListCategory = productsData?.data?.categorizedProducts?.[
      kitchenName
    ]?.NonMealItems?.[product.product_category]?.map((item) => {
      if (item.product_name === product.product_name) {
        return {
          ...item,
          disabled: true,
        };
      }
      return item;
    });

    setProductsData({
      ...productsData,
      data: {
        ...productsData?.data,
        categorizedProducts: {
          ...productsData?.data?.categorizedProducts,
          [kitchenName]: {
            ...productsData?.data?.categorizedProducts?.[kitchenName],
            NonMealItems: {
              ...productsData?.data?.categorizedProducts?.[kitchenName]?.NonMealItems,
              [product.product_category]: newProductListCategory,
            },
          },
        },
      },
    });
  };

  const onAddItemToCart = (product) => {
    // Empty OrderConfirmationData
    setOrderConfirmationData({});
    setPromoCodeOrderSummary({});

    if (
      (!isLoggedIn || (isLoggedIn && !custActType)) &&
      product?.product_type === 'meal_item' &&
      !oneTimeMeal
    ) {
      navigate('/upgradesubscription');
      return;
    }

    // Checking product is from same kitchen
    if (
      sortedKitchenData?.account_type !== 'promotional kitchen' &&
      (cartItems?.mealItems?.length > 0 || cartItems?.nonMealItems?.length > 0)
    ) {
      const kitchenNameOfAddedProducts =
        cartItems?.mealItems?.[0]?.kitchen_name || cartItems?.nonMealItems?.[0]?.kitchen_name;
      if (kitchenNameOfAddedProducts && kitchenName !== kitchenNameOfAddedProducts) {
        setButtonAgreeLabel('Empty bag');
        setdisplayText(
          'Start a new order ? Your bag contains items from another restaurant.Empty your bag to start a new order.'
        );
        setshowAgreeButton(true);
        setshowDisagreeButton(true);
        setAlertOpen(true);
        return;
      }
    }

    // kuldeep changed condition from
    // if (isLoggedIn && custActType && !zeroPlatesAvailable && product?.product_type === 'meal_item' && product.available_quantity > 0) {
    if (
      ((isLoggedIn && custActType && !zeroPlatesAvailable) ||
        (!custActType && oneTimeMeal && howManyPerson)) &&
      product?.product_type === 'meal_item' &&
      product.available_quantity > 0
    ) {
      const mealPlanMap = {
        'one person': 1,
        'two person': 2,
        'four person': 4,
      };
      let mealPlan = custInfoData?.meal_Package?.meal_plan;
      if (oneTimeMeal && howManyPerson) {
        mealPlan = howManyPerson;
      }
      const mealPlanValue = mealPlanMap[mealPlan];
      const allowedMealPlanOffering = {};
      Object.keys(meal_offering).forEach((key) => {
        allowedMealPlanOffering[key] = mealPlanValue * meal_offering[key];
      });
      const allCategoriesToAddInCart = { ...allowedMealPlanOffering };
      cartItems?.mealItems?.forEach((mealItem) => {
        allCategoriesToAddInCart[mealItem.product_category] -= 1;
      });
      allCategoriesToAddInCart[product.product_category] -= 1;
      setRemainingMealItemsCategoryWise({
        showMealItemSnackBar: true,
        items: allCategoriesToAddInCart,
      });

      const inCartMealItem = {};
      cartItems?.mealItems?.forEach((mealItem) => {
        if (!inCartMealItem[mealItem.product_category]) {
          inCartMealItem[mealItem.product_category] = 0;
        }
        inCartMealItem[mealItem.product_category] += 1;
      });

      // console.log('inCartMealItem', inCartMealItem);
      const remainingCategorizedProduct =
        allowedMealPlanOffering[product.product_category] -
        (inCartMealItem[product.product_category] || 0);
      if (remainingCategorizedProduct > 0) {
        // add to cart logic
        const newCartItems = { ...cartItems };
        if (!newCartItems?.mealItems) {
          newCartItems.mealItems = [];
        }
        newCartItems?.mealItems?.push({
          product_name: product.product_name,
          selectedQuantity: 1,
          price: product.price,
          available_quantity: product.available_quantity,
          product_category: product.product_category,
          product_sku: product.product_sku,
          kitchen_name: product.kitchen_name,
          kitchen_id: product.kitchen_id,
        });

        setCartItems({ ...newCartItems });
        if (remainingCategorizedProduct === 1) {
          setDisabledAddToCartBtn_MealItem();
        }
      }
    }

    if (
      product.product_type === 'non_meal_item' &&
      product.available_quantity -
        (cartItems?.nonMealItems?.find(
          (item) =>
            item.product_name === product.product_name &&
            item.product_category === product.product_category
        )?.selectedQuantity || 0) >
        0
    ) {
      // add to cart logic
      let newCartItems = { ...cartItems };
      if (!newCartItems?.nonMealItems) {
        newCartItems.nonMealItems = [];
      }
      const productInCartIndex = newCartItems.nonMealItems?.findIndex(
        (item) =>
          item.product_name === product.product_name &&
          item.product_category === product.product_category
      );
      if (productInCartIndex > -1) {
        if (
          product?.product_promotion?.buy_one_get_one_free &&
          newCartItems.nonMealItems[productInCartIndex].selectedQuantity >= 1
        ) {
          newCartItems.nonMealItems[productInCartIndex].promotion = {
            type: 'buy_one_get_one_free',
            active: true,
          };
        } else if (
          product?.product_promotion?.buy_two_get_one_free &&
          newCartItems.nonMealItems[productInCartIndex].selectedQuantity >= 2
        ) {
          newCartItems.nonMealItems[productInCartIndex].promotion = {
            type: 'buy_two_get_one_free',
            active: true,
          };
        } else if (
          product?.product_promotion?.buy_one_get_half_price &&
          newCartItems.nonMealItems[productInCartIndex].selectedQuantity >= 1
        ) {
          newCartItems.nonMealItems[productInCartIndex].promotion = {
            type: 'buy_one_get_half_price',
            active: true,
          };
        } else {
          delete newCartItems.nonMealItems[productInCartIndex].promotion;
        }
        newCartItems.nonMealItems[productInCartIndex].selectedQuantity += 1;
      } else {
        const productObj = {
          product_name: product.product_name,
          selectedQuantity: 1,
          available_quantity: product.available_quantity,
          price: product.price,
          product_category: product.product_category,
          product_sku: product.product_sku,
          kitchen_name: product.kitchen_name,
          kitchen_id: product.kitchen_id,
        };
        if (product?.product_promotion?.buy_one_get_one_free) {
          productObj.promotion = { type: 'buy_one_get_one_free', active: false };
        } else if (product?.product_promotion?.buy_two_get_one_free) {
          productObj.promotion = { type: 'buy_two_get_one_free', active: false };
        } else if (product?.product_promotion?.buy_one_get_half_price) {
          productObj.promotion = { type: 'buy_one_get_half_price', active: false };
        }
        newCartItems.nonMealItems.push(productObj);
      }

      setCartItems({ ...newCartItems });

      if (
        product.available_quantity -
          (newCartItems?.nonMealItems?.find(
            (item) =>
              item.product_name === product.product_name &&
              item.product_category === product.product_category
          )?.selectedQuantity || 0) ===
        0
      ) {
        setDisabledAddToCartBtn_NonMealItem();
      }
    }
  };

  const clickRedirectPdp = async (product) => {
    setProductsData(product);
    setStoreName(product.kitchen_name);
    await navigate(
      `/onthemenu/storemenu/pdp?storename=${product.kitchen_name}&productname=${product.product_name}`
    );
  };

  const getProductCount = (productName) => {
    if (product?.product_type === 'non_meal_item') {
      return cartItems?.nonMealItems?.find((item) => {
        return item.product_name === productName;
      })?.selectedQuantity;
    }
    if (product?.product_type === 'meal_item') {
      let count = 0;
      cartItems?.mealItems?.forEach((item) => {
        if (item.product_name === productName) {
          count++;
        }
      });
      return count;
    }
  };

  const productCount = getProductCount(product?.product_name);

  const ProdCardWidth = () =>
    [
      'starters_and_sides',
      'desserts_and_drinks',
      'kids',
      'kids_menu',
      'party_pack',
      'side',
      'complementry',
      'promotional',
    ].includes(product?.product_category);

  // We have same code on pdp.jsx
  const productPromotionKeys = Object.keys(product.product_promotion || {});
  let productPromotionActiveKey = null;
  for (let i = 0; i < productPromotionKeys.length; i++) {
    const key = productPromotionKeys[i];
    if (product.product_promotion[key]) {
      productPromotionActiveKey = key;
      break;
    }
  }

  const checkPromoKeyName = productPromotionActiveKey === 'buy_one_get_half_price';
  const checkPromoKeyBuy2 = productPromotionActiveKey === 'buy_two_get_one_free';

  if (isMobile) {
    return (
      <>
        <AlertDialog
          isLoading={false}
          open={isAlertOpen}
          setOpen={setAlertOpen}
          onAgree={onAlertAgree}
          onDisagree={onAlertDisagree}
          buttonAgreeLabel={buttonAgreeLabel}
          buttonDisagreeLabel='Cancel'
          displayText={displayText}
          showAgreeButton={showAgreeButton}
          showDisagreeButton={showDisagreeButton}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'space-between',
            width: 'none',
            // height: '390px',
            border: '1px solid #ECECEC',
            margin: '5px',
            borderRadius: 5,
            minWidth: '150px',
            height: ProdCardWidth() ? 'auto' : '400px',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              height: product.image_url === null ? '70%' : null,
              borderRadius: '5px 5px 0px 0px',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              objectFit: 'cover',
              cursor: 'pointer',
              position: 'relative',
            }}
          >
            {productCount > 0 && (
              <div
                style={{
                  zIndex: 1,
                  right: '8px',
                  top: '8px',
                  position: 'absolute',
                  background: '#E0E0E0',
                  color: '#181436',
                  padding: '5px',
                  width: '20px',
                  borderRadius: '15px',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '14px',
                }}
              >
                {' '}
                {productCount}
              </div>
            )}

            {productPromotionActiveKey && product?.product_type === 'non_meal_item' && (
              <div
                style={{
                  zIndex: 1,
                  left: '8px',
                  top: '8px',
                  position: 'absolute',
                  background: checkPromoKeyName
                    ? 'rgb(254, 236, 190)'
                    : checkPromoKeyBuy2
                      ? '#FF7A28'
                      : 'rgb(149, 237, 135)',
                  color: checkPromoKeyBuy2 ? 'white' : '#181436',
                  padding: '5px',
                  width: 'auto',
                  borderRadius: '5px',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '13px',
                  fontFamily: 'Inter Medium',
                  letterSpacing: '0.5px',
                }}
              >
                {' '}
                {TextTransformation(productPromotionActiveKey)}
              </div>
            )}

            <img
              width={imageLoaded ? '100%' : 0}
              src={
                imageError
                  ? fallBackImage
                  : imageUrlTransformation({
                      imageUrl: product.image_url,
                      fillType: 'fill',
                      width: ProdCardWidth() ? 250 : 500,
                    })
              }
              onLoad={() => onImageLoad()}
              onError={() => onImageError()}
              onClick={() => {
                clickRedirectPdp(product);
              }}
            />
            {!imageLoaded && <Loader color='black' width='20px' height='20px' />}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              height: 'auto',
              padding: '10px 10px 10px 15px',
            }}
          >
            <div style={{ width: '85%' }}>
              <div
                style={{
                  fontSize: ProdCardWidth() ? '16px' : '18px',
                  fontFamily: 'Inter Bold',
                  letterSpacing: '0.8px',
                  color: '#181436',
                  textTransform: 'capitalize',
                }}
              >
                {product?.product_name}
              </div>
              <div
                style={{
                  fontSize: '14px',
                  fontFamily: 'Inter Regular',
                  letterSpacing: '0.5px',
                  color: '#A8A4BF',
                }}
              >
                {' '}
                {product?.recipe_with}
              </div>

              {mealType === 'Combo Menu' ? (
                <div
                  style={{
                    fontSize: '12px',
                    fontFamily: 'Inter Regular',
                    color: '#FF7A28',
                    marginTop: '5px',
                  }}
                >
                  Meal Price $0.00
                </div>
              ) : (
                <div
                  style={{
                    fontSize: '16px',
                    fontFamily: 'Inter Medium',
                    color: '#181436',
                    marginTop: '5px',
                  }}
                >
                  ${product?.price}
                </div>
              )}

              {IsFreeProduct && PromoVerbage()}

              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '10px' }}>
                {product?.special_marking?.map((g, index) => {
                  return (
                    <Avatar
                      alt='Remy Sharp'
                      src={SpecialMarkingIcons[g]}
                      sx={{ width: 20, height: 20, marginRight: '5px' }}
                      key={`${index}_specialmarking`}
                    />
                  );
                })}
              </div>
            </div>
            <div style={{ position: 'relative', top: '-25px' }}>
              <AtomicCircleButton
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  onAddItemToCart(product);
                }}
                disabled={product?.disabled}
              />
              {product?.disabled && product?.product_type === 'non_meal_item' && (
                <div
                  style={{
                    borderRadius: '3px',
                    color: 'white',
                    fontSize: '8px',
                    background: '#FF7A28',
                    padding: '5px',
                  }}
                >
                  {' '}
                  SOLD OUT
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  if (isIpad) {
    return (
      <>
        <AlertDialog
          isLoading={false}
          open={isAlertOpen}
          setOpen={setAlertOpen}
          onAgree={onAlertAgree}
          onDisagree={onAlertDisagree}
          buttonAgreeLabel={buttonAgreeLabel}
          buttonDisagreeLabel='Cancel'
          displayText={displayText}
          showAgreeButton={showAgreeButton}
          showDisagreeButton={showDisagreeButton}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'space-between',
            width: generateWidthByscreenSize(),
            // height: '390px',
            border: '1px solid #ECECEC',
            margin: '5px 10px',
            borderRadius: 5,
            minWidth: '150px',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              height: product.image_url === null ? '70%' : null,
              borderRadius: '5px 5px 0px 0px',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              objectFit: 'cover',
              cursor: 'pointer',
              position: 'relative',
            }}
          >
            {productCount > 0 && (
              <div
                style={{
                  zIndex: 1,
                  right: '8px',
                  top: '8px',
                  position: 'absolute',
                  background: '#E0E0E0',
                  color: '#181436',
                  padding: '5px',
                  width: '20px',
                  borderRadius: '15px',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '14px',
                }}
              >
                {' '}
                {productCount}
              </div>
            )}

            {productPromotionActiveKey && product?.product_type === 'non_meal_item' && (
              <div
                style={{
                  zIndex: 1,
                  left: '8px',
                  top: '8px',
                  position: 'absolute',
                  background: checkPromoKeyName
                    ? 'rgb(254, 236, 190)'
                    : checkPromoKeyBuy2
                      ? '#FF7A28'
                      : 'rgb(149, 237, 135)',
                  color: checkPromoKeyBuy2 ? 'white' : '#181436',
                  padding: '5px',
                  width: 'auto',
                  borderRadius: '5px',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontFamily: 'Inter Medium',
                  letterSpacing: '0.5px',
                }}
              >
                {' '}
                {TextTransformation(productPromotionActiveKey)}
              </div>
            )}

            <img
              width={imageLoaded ? '100%' : 0}
              src={
                imageError
                  ? fallBackImage
                  : imageUrlTransformation({
                      imageUrl: product.image_url,
                      fillType: 'fill',
                      width: 250,
                    })
              }
              onLoad={() => onImageLoad()}
              onError={() => onImageError()}
              onClick={() => {
                clickRedirectPdp(product);
              }}
            />
            {!imageLoaded && <Loader color='black' width='20px' height='20px' />}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              height: 'auto',
              padding: '10px 10px 10px 15px',
            }}
          >
            <div style={{ width: '78%' }}>
              <div
                style={{
                  fontSize: '16px',
                  fontFamily: 'Inter Medium',
                  letterSpacing: '0.5px',
                  color: '#181436',
                  textTransform: 'capitalize',
                }}
              >
                {product?.product_name}
              </div>
              <div
                style={{
                  fontSize: '14px',
                  fontFamily: 'Inter Regular',
                  letterSpacing: '0.4px',
                  color: '#A8A4BF',
                }}
              >
                {' '}
                {product?.recipe_with}
              </div>

              {mealType === 'Combo Menu' ? (
                <div
                  style={{
                    fontSize: '12px',
                    fontFamily: 'Inter Medium',
                    color: '#FF7A28',
                    marginTop: '10px',
                  }}
                >
                  Meal Price $0.00
                </div>
              ) : (
                <div
                  style={{
                    fontSize: '14px',
                    fontFamily: 'Inter Medium',
                    color: '#181436',
                    marginTop: '5px',
                  }}
                >
                  ${product?.price}
                </div>
              )}

              {IsFreeProduct && PromoVerbage()}

              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '15px' }}>
                {product?.special_marking?.map((g, index) => {
                  return (
                    <Avatar
                      alt={g}
                      src={SpecialMarkingIcons[g]}
                      sx={{ width: 20, height: 20, marginRight: '5px' }}
                      key={`${index}_specialmarking`}
                    />
                  );
                })}
              </div>
            </div>
            <div style={{ position: 'relative', top: '-25px' }}>
              <AtomicCircleButton
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  onAddItemToCart(product);
                }}
                disabled={product?.disabled}
              />
              {product?.disabled && product?.product_type === 'non_meal_item' && (
                <div
                  style={{
                    borderRadius: '3px',
                    color: 'white',
                    fontSize: '8px',
                    background: '#FF7A28',
                    padding: '5px',
                  }}
                >
                  {' '}
                  SOLD OUT
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  if (isDesktop) {
    return (
      <>
        <AlertDialog
          isLoading={false}
          open={isAlertOpen}
          setOpen={setAlertOpen}
          onAgree={onAlertAgree}
          onDisagree={onAlertDisagree}
          buttonAgreeLabel={buttonAgreeLabel}
          buttonDisagreeLabel='Cancel'
          displayText={displayText}
          showAgreeButton={showAgreeButton}
          showDisagreeButton={showDisagreeButton}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'space-between',
            width: generateWidthByscreenSize(),
            // height: '390px',
            border: '1px solid #ECECEC',
            margin: '5px 10px',
            borderRadius: 5,
            minWidth: '150px',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              height: product.image_url === null ? '70%' : null,
              borderRadius: '5px 5px 0px 0px',
              overflow: 'hidden',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              objectFit: 'cover',
              cursor: 'pointer',
              position: 'relative',
            }}
          >
            {productCount > 0 && (
              <div
                style={{
                  zIndex: 1,
                  right: '8px',
                  top: '8px',
                  position: 'absolute',
                  background: '#E0E0E0',
                  color: '#181436',
                  padding: '5px',
                  width: '20px',
                  borderRadius: '15px',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '14px',
                }}
              >
                {' '}
                {productCount}
              </div>
            )}

            {productPromotionActiveKey && product?.product_type === 'non_meal_item' && (
              <div
                style={{
                  zIndex: 1,
                  left: '8px',
                  top: '8px',
                  position: 'absolute',
                  background: checkPromoKeyName
                    ? 'rgb(254, 236, 190)'
                    : checkPromoKeyBuy2
                      ? '#FF7A28'
                      : 'rgb(149, 237, 135)',
                  color: checkPromoKeyBuy2 ? 'white' : '#181436',
                  padding: '5px',
                  width: 'auto',
                  borderRadius: '5px',
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  fontSize: '14px',
                  fontFamily: 'Inter Medium',
                  letterSpacing: '0.5px',
                }}
              >
                {' '}
                {TextTransformation(productPromotionActiveKey)}
              </div>
            )}
            <img
              width={imageLoaded ? '100%' : 0}
              src={
                imageError
                  ? fallBackImage
                  : imageUrlTransformation({
                      imageUrl: product.image_url,
                      fillType: 'fill',
                      height: 500,
                      width: 500,
                    })
              }
              onLoad={() => onImageLoad()}
              onError={() => onImageError()}
              onClick={() => {
                clickRedirectPdp(product);
              }}
            />
            {!imageLoaded && <Loader color='black' width='20px' height='20px' />}
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              height: 'auto',
              padding: '10px 10px 10px 15px',
            }}
          >
            <div style={{ width: '83%' }}>
              <div
                style={{
                  fontSize: '16px',
                  fontFamily: 'Inter Medium',
                  color: '#181436',
                  letterSpacing: '0.5px',
                  textTransform: 'capitalize',
                }}
              >
                {product?.product_name}
              </div>
              <div
                style={{
                  fontSize: '14px',
                  fontFamily: 'Inter Regular',
                  letterSpacing: '0.4px',
                  color: '#A8A4BF',
                }}
              >
                {' '}
                {product?.recipe_with}
              </div>

              {mealType === 'Combo Menu' ? (
                <div
                  style={{
                    fontSize: '12px',
                    fontFamily: 'Roboto',
                    color: '#FF7A28',
                    marginTop: '5px',
                  }}
                >
                  Meal Price $0.00
                </div>
              ) : (
                <div
                  style={{
                    fontSize: '14px',
                    fontFamily: 'Inter Medium',
                    color: '#181436',
                    marginTop: '5px',
                  }}
                >
                  ${product?.price}
                </div>
              )}

              {IsFreeProduct && PromoVerbage()}

              <div style={{ display: 'flex', flexDirection: 'row', marginTop: '15px' }}>
                {product?.special_marking?.map((g, index) => {
                  return (
                    <Avatar
                      alt={g}
                      src={SpecialMarkingIcons[g]}
                      sx={{ width: 24, height: 24, marginRight: '8px' }}
                      key={`${index}_specialmarking`}
                    />
                  );
                })}
              </div>
            </div>

            <div style={{ position: 'relative', top: '-25px' }}>
              <AtomicCircleButton
                style={{ marginLeft: '5px' }}
                onClick={() => {
                  onAddItemToCart(product);
                }}
                disabled={product?.disabled}
              />
              {product?.disabled && product?.product_type === 'non_meal_item' && (
                <div
                  style={{
                    borderRadius: '3px',
                    color: 'white',
                    fontSize: '8px',
                    background: '#FF7A28',
                    padding: '5px',
                  }}
                >
                  {' '}
                  SOLD OUT
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default ProductCard;
